import { useMemo } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';
import { useUsersData } from '../Helpers/UsersContext';

/**
 * Hook to check if the current user is an admin.
 * Returns true if the user is authenticated and has admin: true in their user profile.
 */
export function useIsAdmin(): boolean {
    const [user] = useAuthState(auth);
    const { users } = useUsersData();

    return useMemo(() => {
        if (!user || !users) return false;
        const currentUser = users.find(u => u.key === user.uid);
        return currentUser?.admin || currentUser?.superadmin || false;
    }, [user, users]);
}

/** Whether the current user is a superadmin. */
export function useIsSuperadmin(): boolean {
    const [user] = useAuthState(auth);
    const { users } = useUsersData();

    return useMemo(() => {
        if (!user || !users) return false;
        return users.find(u => u.key === user.uid)?.superadmin || false;
    }, [user, users]);
}
